<template>
  <div class="wrapper">
    <side-bar
      type="sidebar"
      :sidebar-links="myLinks"
      v-bind:title="appTitle"
      backgroundColor="white">
      <user-menu></user-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar :contentTitle="contentTitle"></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import UserMenu from "@/components/UIComponents/SidebarPlugin/UserMenu.vue";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    UserMenu
  },
  data() {
    return {
      contentTitle: "Not Set"
    };
  },
  watch: {
    $route(to, from) {
      try {
        this.contentTitle = to.meta.title;
        if (this.contentTitle.length === 0) {
          this.contentTitle = "Not Set";
        }
      } catch (error) {
        this.contentTitle = "Not Set";
      }

      console.log("Returning " + this.contentTitle);
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  computed: {
    appTitle: function() {
      return process.env.VUE_APP_TITLE;
    },
    oidcUser() {
      return this.$store.state.oidcStore.user;
    },
    myLinks: function() {
      var links = [];

      var myGroups = this.oidcUser.groups;
      console.log("My groups: " + myGroups);
      this.$sidebar.sidebarLinks.forEach(function(navItem) {
        if (
          navItem.meta != undefined &&
          navItem.meta.roles != undefined &&
          navItem.meta.roles.length > 0
        ) {
          console.log("Item: " + navItem.name + " Role: " + navItem.meta.roles);

          for (
            let roleIndex = 0;
            roleIndex < navItem.meta.roles.length;
            roleIndex++
          ) {
            if (myGroups.indexOf(navItem.meta.roles[roleIndex]) > -1) {
              links.push(navItem);
              break;
            }
          }
        } else {
          links.push(navItem);
        }
      });
      return links;
    }
  },
  mounted() {
    try {
      this.contentTitle = this.$route.meta.title;
      if (this.contentTitle.length === 0) {
        this.contentTitle = "Not Set";
      }
    } catch (error) {
      this.contentTitle = "Not Set";
    }
  }
};
</script>
<style lang="scss">
    $scaleSize: 0.95;
    @keyframes zoomIn95 {
        from {
            opacity: 0;
            transform: scale3d($scaleSize, $scaleSize, $scaleSize);
        }
        to {
            opacity: 1;
        }
    }
    .main-panel .zoomIn {
        animation-name: zoomIn95;
    }
    @keyframes zoomOut95 {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
            transform: scale3d($scaleSize, $scaleSize, $scaleSize);
        }
    }
    .main-panel .zoomOut {
        animation-name: zoomOut95;
    }
</style>

